import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { SaveMappingConfigDialogComponent } from '../../save-mapping-config-dialog/save-mapping-config-dialog.component';
import { BaseComponent } from '../../../base/base.component';
import { ErrorReportingService } from '../../../services/errorReporting/error-reporting.service';
import { SharedService } from 'src/app/services/shared.service';
import { KeyboardService } from 'src/app/services/keyboard/keyboard.service';

@Component({
    selector: 'app-new-single-string-value-dialog',
    templateUrl: './new-single-string-value-dialog.component.html',
    styleUrls: ['./new-single-string-value-dialog.component.css'],
    standalone: false
})
export class NewSingleStringValueDialogComponent extends BaseComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  stringValue: string;
  placeholder: string;
  title: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<SaveMappingConfigDialogComponent>,
    matDialog: MatDialog,
    private sharedService: SharedService,private keyboardService: KeyboardService,
    logger: ErrorReportingService) {
    super(logger, matDialog);
  }

  ngOnInit(): void {
    this.stringValue = this.data.stringValue;
    this.placeholder = this.data.placeholder;
    this.title = this.data.title;
  }
  ngAfterViewInit(): void {
    this.keyboardService.onKey('Escape', () => {
      this.cancel();
    }, this.destroyRef);
  }
  onEnter(event: Event): void {
    // Commit the current input text before validating, and stop the event from
    // reaching the shared KeyboardService's stale document-level Enter handlers.
    event.preventDefault();
    event.stopPropagation();
    const value = (event.target as HTMLInputElement)?.value;
    if (value != null) { this.stringValue = value; }
    this.save();
  }

  save(): void {
    if ( !this.stringValue || this.stringValue.length === 0 ) {
      // this.displayError('You must enter a value', 'Required field');
      return;
    }

    this.dialogRef.close({stringValue: this.stringValue, });
  }

  cancel(): void {
    this.sharedService.sendEvent("cancel_dialog_clicked");
    this.dialogRef.close();
  }
}
